export const HeaderWrapper = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <div
      onClick={onClick}
      className="flex flex-row items-center justify-center h-full "
    >
      {children}
    </div>
  );
};
